<template>
    <div class="monibox-main-container">
        <LeftMenu
            @updateTab="selectedTab = $event"
            v-if="!isCreateRoute && verifications"
        />
        <div
            v-show="verifications && !loading"
            class="monibox-content-wrapper"
            :class="isCreateRoute ? 'padding-create' : null"
        >
            <ClassicBreadCrumb :title="routeName" v-if="canBeDisplayed" />
            <div
                :class="isCreateRoute ? 'create-wrapper' : null"
                class="content-wrapper"
            >
                <CreateOrEdit
                    v-if="selectedTab === 'generalInfos' || isCreateRoute"
                    @change-monibox-name="moniboxName = $event"
                    @loading="updateLoading"
                />
                <LifeCycle
                    v-if="selectedTab === 'lifeCycle' && !isCreateRoute"
                    @loading="updateLoading"
                />
            </div>
        </div>
        <div v-show="!verifications || loading" class="loader">
            <Loader />
        </div>
    </div>
</template>

<script>
import { useToast } from "vue-toastification"

import LeftMenu from "@/views/monibox/LeftMenu.vue"
import CreateOrEdit from "@/views/monibox/CreateOrEdit.vue"
import LifeCycle from "@/views/monibox/LifeCycle.vue"
import ClassicBreadCrumb from "@/components/entities/ClassicBreadCrumb.vue"
import Loader from "@/components/basic/Loader.vue"

const toast = useToast()

export default {
    components: {
        LeftMenu,
        CreateOrEdit,
        LifeCycle,
        ClassicBreadCrumb,
        Loader,
    },

    data() {
        return {
            verifications: false,
            loading: false,
            selectedTab: "generalInfos",
            moniboxName: null,
        }
    },

    computed: {
        routeName() {
            return this.$route.params.action === "edit"
                ? this.moniboxName
                : this.$t("monibox.form.add")
        },
        isCreateRoute() {
            return this.$route.params.action === "create"
        },
        canBeDisplayed() {
            if (!this.isCreateRoute) {
                if (this.moniboxName) {
                    return true
                }

                return false
            }

            return true
        },
        breadcrumb() {
            return this.$store.getters["breadCrumb/getClassicBreadCrumb"]
        },
    },

    methods: {
        updateLoading(value) {
            this.loading = value
        },
    },

    created() {
        if (
            this.breadcrumb[this.breadcrumb.length - 1].routeName ===
            "Residences"
        ) {
            toast.warning(this.$t("alerts.navigations.notAccessible"))
            this.$router.go(-1)
        } else {
            this.verifications = true
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

.monibox-main-container {
    width: 100%;
    height: 100%;
    display: flex;

    .monibox-content-wrapper {
        width: 100%;
        padding: 20px 4em;
        height: 100%;
        min-width: 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: 1em;

        @media all and (max-width: 1024px) {
            padding: 20px;
        }

        .content-wrapper {
            width: 100%;
            flex: 1 1 auto;
            min-height: 0;
        }
    }

    .create-wrapper {
        display: flex;
        gap: 2em;
        height: 100%;

        .separator {
            width: 1px;
            height: 100%;
            border: 1px solid $blue-neutral;
        }
    }

    .padding-create {
        padding: 20px 80px 20px 80px;
    }
}

.loader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
